<template>
  <svg :fill="color" x="0" y="0" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.89 49c-.46 0-.92-.17-1.26-.52-.7-.7-.7-1.83 0-2.53L33.58 25 12.63 4.05c-.7-.7-.7-1.83 0-2.53s1.83-.7 2.53 0l22.21 22.21c.34.34.52.79.52 1.26s-.19.93-.52 1.26L15.16 48.48c-.35.35-.81.52-1.27.52z" style="fill:#05b4ff"/>
  </svg>
</template>

<script>
export default {
  name: 'IconChevronRight',
  props: {
    color: {
      type: String,
      default: '#24b9ec'
    }
  }
}
</script>

